import type {InterfaceModel} from '../model';
import {contentFor} from '../model';

export function OriginRail({model,scope}:{model:InterfaceModel;scope?:string}){
  const distribution=model.distribution;
  const contract=contentFor(model,'origin-contract')[0];
  return <aside className="tu-panel tu-origin-panel" aria-label="View origin">
    <header><div><span>Where this view came from</span><h2>{distribution.disclosureLevel==='authorized-detail'?'Authorized detail':'Public summary'}</h2></div></header>
    <dl className="tu-contract-dl">
      <div><dt>Interface client</dt><dd><code>{distribution.clientIdentity}</code></dd></div>
      <div><dt>Distribution</dt><dd><code>{distribution.identity}</code><small>{distribution.revision}</small></dd></div>
      <div><dt>Brand</dt><dd><code>{distribution.brandProfileIdentity}</code></dd></div>
      <div><dt>Terminology</dt><dd><code>{distribution.terminologyProfileIdentity}</code></dd></div>
      {scope?<div><dt>Tenant scope</dt><dd><code>{scope}</code><small>Independent of distribution and brand</small></dd></div>:null}
      <div><dt>Admitted build input</dt><dd><code>{model.provenance.admittedGraph.identity}</code><small>{model.provenance.projections.length} typed projections</small></dd></div>
    </dl>
    {contract?<details><summary>{contract.title}</summary><p>{contract.body}</p></details>:null}
  </aside>;
}
